import { WebStorageStateStore } from "oidc-client-ts";
import { AMAZON_FEDERATE_PROD } from "../utils/detectEnv";

export const getOidcConfig = () => {
  const authority = AMAZON_FEDERATE_PROD;

  return {
    authority,
    client_id: "WHS-Safer-Saige",
    redirect_uri: "https://beta.eu.safer.whs.amazon.dev/idpresponse",
    silent_redirect_uri: "https://beta.eu.safer.whs.amazon.dev/silent-callback.html",
    response_type: "code",
    scope: "openid profile email",
    automaticSilentRenew: false,
    silentRequestTimeoutInSeconds: 3,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
  };
};
